import type { Asset } from "contentful";

import type { ContentfulCardFields } from "./card";
import { createUseQueryEntry } from "./client";

export interface ContentfulGridBlockFields {
	title: string;
	titleHighlightText: string;
	subtitle: string;
	gridItems: Array<ContentfulCardFields>;
	gridMediaItems: Array<Asset>;
}

export const CONTENTFUL_PLAYGROUND_WELCOME_PAGE_USE_CASE_CARDS_BLOCK = "4AN9bJV8YNsuQWm0lwA83t";
export const useQueryPlaygroundWelcomePageUseCaseCardsBlock = createUseQueryEntry<ContentfulGridBlockFields>(
	CONTENTFUL_PLAYGROUND_WELCOME_PAGE_USE_CASE_CARDS_BLOCK,
);

export const CONTENTFUL_PLAYGROUND_WELCOME_PAGE_INTEGRATIONS_BLOCK = "4qlzi07w888xB4Wmj2Q6Fj";
export const useQueryPlaygroundWelcomePageIntegrationsBlock = createUseQueryEntry<ContentfulGridBlockFields>(
	CONTENTFUL_PLAYGROUND_WELCOME_PAGE_INTEGRATIONS_BLOCK,
);
